var _ = require('lodash')

export default {
    bind: function (el, binding, vnode) {
        var el = document
        var lastscroll = 0

        $(el).on('scroll', function () {
            var height = $(el).height() - $(window).height()
            var position = $(el).scrollTop()

            // A browser may try to remember your previous scroll position on
            // page refresh which can cause issues with infinite scroll.
            // If the current position is at the top (such as when a page refresh occurs)
            // Reset the lastscroll to 0
            if (position == 0) {
                lastscroll = position
            }

            var scrolling_down = position >= lastscroll

            // If position is less then 1000 px form the bottom and scrolling down
            if (position >= height - 1000 && scrolling_down) {
                lastscroll = position
                binding.value()
            }
        })
    }
}
